export default __webpack_public_path__ + "static/media/Liang­Fang Chao.7f7536ca.png";